import { render, staticRenderFns } from "./SecStudy_SKMJ.vue?vue&type=template&id=033d3273&scoped=true&"
import script from "./SecStudy_SKMJ.vue?vue&type=script&lang=js&"
export * from "./SecStudy_SKMJ.vue?vue&type=script&lang=js&"
import style0 from "./SecStudy_SKMJ.vue?vue&type=style&index=0&id=033d3273&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033d3273",
  null
  
)

export default component.exports